import React, { useState } from 'react';
import { toast } from 'sonner';
import { Loader2, Navigation, MapPinned, CheckCircle2 } from 'lucide-react';

const STEPS = [
  { key: 'on_the_way', label: 'On my way', icon: Navigation, cls: 'bg-sky-600 hover:bg-sky-700' },
  { key: 'arrived', label: 'Arrived', icon: MapPinned, cls: 'bg-amber-500 hover:bg-amber-600' },
  { key: 'done', label: 'Job done', icon: CheckCircle2, cls: 'bg-emerald-600 hover:bg-emerald-700' },
];

export const StatusButtons = ({ job, authFetch, onUpdated }) => {
  const [busy, setBusy] = useState(null);
  const currentIdx = STEPS.findIndex(s => s.key === job.job_status);

  const set = async (key) => {
    if (key === 'done' && !window.confirm(`Mark #${job.ref} as done?`)) return;
    if (job.job_status === 'done' && key !== 'done' && !window.confirm(`#${job.ref} is marked done. Re-open it?`)) return;
    setBusy(key);
    try {
      const { data } = await authFetch('post', `/jobs/${job.id}/status`, { status: key });
      const label = STEPS.find(s => s.key === key).label;
      toast.success(data.emailed ? `${label} · customer emailed.` : `${label} · office updated.`);
      onUpdated?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Couldn't update status.");
    } finally { setBusy(null); }
  };

  return (
    <div className="grid grid-cols-3 gap-2" data-testid={`job-status-${job.ref}`}>
      {STEPS.map((s, i) => {
        const Icon = s.icon;
        const reached = currentIdx >= i;
        const isNext = i === currentIdx + 1;
        return (
          <button
            key={s.key}
            type="button"
            onClick={() => set(s.key)}
            disabled={!!busy}
            className={`h-12 rounded-md text-white text-xs sm:text-sm font-black inline-flex flex-col sm:flex-row items-center justify-center gap-1 transition-[opacity,background-color] ${reached ? s.cls : isNext ? `${s.cls} ring-2 ring-offset-1 ring-slate-300` : 'bg-slate-300 hover:bg-slate-400'} ${reached && !isNext ? 'opacity-100' : ''}`}
            data-testid={`job-status-btn-${s.key}-${job.ref}`}
          >
            {busy === s.key ? <Loader2 className="w-4 h-4 animate-spin" /> : <Icon className="w-4 h-4" />}
            {s.label}{reached && ' ✓'}
          </button>
        );
      })}
    </div>
  );
};
